import React from "react";
import { TimeOptions, StyledTimeListItem, StyledComment } from "../dashboard.style";

const TimeMenu = ({ selectTime, timeSelected }) => {
  return (
    <TimeOptions>
      <StyledTimeListItem key="TODAY" value="TODAY" onClick={selectTime} selected={timeSelected === "TODAY"}>
        Today
      </StyledTimeListItem>
      <StyledTimeListItem key="LAST_7_DAYS" value="LAST_7_DAYS" onClick={selectTime} selected={timeSelected === "LAST_7_DAYS"}>
        Last 7 Days
      </StyledTimeListItem>
      <StyledTimeListItem key="LAST_14_DAYS" value="LAST_14_DAYS" onClick={selectTime} selected={timeSelected === "LAST_14_DAYS"}>
        Last 14 Days
      </StyledTimeListItem>
      <StyledTimeListItem key="LAST_30_DAYS" value="LAST_30_DAYS" onClick={selectTime} selected={timeSelected === "LAST_30_DAYS"}>
        Last 30 Days
      </StyledTimeListItem>
      {timeSelected === "TODAY" && <StyledComment>🕑 Data shown for today is updated hourly</StyledComment>}
    </TimeOptions>
  );
};
export default TimeMenu;
